import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from './messages';
import { UnverifiedWrapper } from './ApplicationUnverifiedLabel.styles';

type ApplicationUnverifiedLabelProps = {
  isVerified: boolean;
};

export const ApplicationUnverifiedLabel = ({ isVerified }: ApplicationUnverifiedLabelProps) => {
  return isVerified ? null : (
    <UnverifiedWrapper data-testid="unverified-label">
      <FormattedMessage {...messages.unverified} />
      {'- '}
      <FormattedMessage {...messages.unverifiedMessage} />
    </UnverifiedWrapper>
  );
};
